import { LineChart, Presentation, FileBarChart2, KeyRound, FileText } from "lucide-react";

/**
 * The five buttons on the Reports page, in the order Christian listed them
 * (Monday 13377706735, 25 Oct 2026): "Make it 1 tab called REPORTS. When they
 * click Reports send it to a page where we have 5 big blue buttons ... Connect
 * everything we have built to each of these buttons".
 *
 * Each button opens a page that already exists; nothing moved. The three CMA
 * buttons open the CMA page with their tile already picked, through the same
 * `?type=` the CMA page keeps in its URL (see cmaReportTypes.js).
 *
 * `comingSoon` greys a button for agents while admins can still open it to
 * review, the same rule as ComingSoonRoute. No button uses it now: Market
 * Update and CMA opened to agents on 29 Oct 2026, after Christian sent the
 * tab back because agents could not click any of the five.
 *
 * `notBuilt` is for Listing Proposals, which has no page yet. It is closed for
 * everyone, admins included, because there is nothing behind it to review.
 */
export const REPORT_BUTTONS = [
  {
    key: "market_update",
    label: "Market Update",
    hint: "A property or suburb update for your vendors, by SMS and email",
    icon: LineChart,
    to: "/prospecting/market-update",
  },
  {
    key: "listing_proposal",
    label: "Listing Proposals",
    hint: "Your pitch to win the listing",
    icon: Presentation,
    to: null,
    notBuilt: true,
  },
  {
    key: "sales_cma",
    label: "Sales CMA Report",
    hint: "Compare recent sales to price a property for a vendor",
    icon: FileBarChart2,
    to: "/prospecting/cma",
  },
  {
    key: "rental_cma",
    label: "Rental CMA Report",
    hint: "Compare leased properties to price a rental for a landlord",
    icon: KeyRound,
    to: "/prospecting/cma?type=rental",
  },
  {
    key: "price_statement",
    label: "Property Price Statement",
    hint: "The Section 47AF statement, published as a public link",
    icon: FileText,
    to: "/prospecting/cma?type=price_statement",
  },
];

/**
 * The report pages keep their /prospecting/... routes so existing links and
 * bookmarks still work. These prefixes light the Reports tab up on them.
 */
export const REPORTS_ROUTE_PREFIXES = ["/reports", "/prospecting/market-update", "/prospecting/cma"];

/** Whether a button can be opened by this user. */
export const isReportOpen = (button, isAdmin) =>
  !button.notBuilt && (!button.comingSoon || isAdmin);
